import { localeDate } from '@/utils/utils'

export default function dateFormat(date, format = 'YYYY/MM/DD') {
  return localeDate(date, format)
}
